import React, {Component,Fragment} from 'react';
import {Col, Container, Row} from "react-bootstrap";


import imagePlaceholder from '../Assets/Images/imagePlaceholder.svg';
import * as faceapi from "face-api.js";
import Loader from "./Loader";
import cogoToast from "cogo-toast";


import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {Animated} from "react-animated-css";


class FaceMatch extends Component {
    constructor(props) {
        super(props);
        this.state={
            loaderDIV:"d-none",
            FirstPhotoSrc:imagePlaceholder,
            SecondPhotoSrc:imagePlaceholder,
            FirstPhotoDes:[],
            SecondPhotoDes:[],
            similarity:0,
            distance:0,
            result:"....."
        };
    }

    // First Photo
    FirstPhotoOnChange=()=>{
       let FirstPhotoFile=this.FirstPhoto.files[0];
       let FirstPhotoFileExtension=FirstPhotoFile.name.split('.').pop();
       let validFileExtensions = ["jpg",'JPG',"jpeg",'JPEG',"PNG", "png","gif","GIF"];
       if(!validFileExtensions.includes(FirstPhotoFileExtension)){
            cogoToast.error("Only jpg/png/gif file allowed",{position:"bottom-center"});
       }
       else {
            let reader=new FileReader();
            reader.onload=(e)=>{
            this.setState({FirstPhotoSrc:e.target.result});
            };
            reader.readAsDataURL(FirstPhotoFile);
            this.FirstPhotoDesCal();
       }
    }
    FirstPhotoDesCal=()=>{
        (async ()=>{
            this.setState({loaderDIV:""});
            await  faceapi.loadSsdMobilenetv1Model('/models');
            await  faceapi.loadFaceLandmarkModel('/models');
            await  faceapi.loadFaceRecognitionModel('/models');
            const img=document.getElementById('firstPerson');
            const SingleFace= await faceapi.detectSingleFace(img);
            if(SingleFace){
                const imgDes= await faceapi.detectSingleFace(img).withFaceLandmarks().withFaceDescriptor();
                if(imgDes['descriptor']){
                    this.setState({
                        FirstPhotoDes:imgDes['descriptor']
                    });
                    this.setState({loaderDIV:"d-none"});
                }
                else {
                    this.setState({loaderDIV:"d-none",FirstPhotoSrc:imagePlaceholder});
                    cogoToast.error("No face detected ! Try again",{position:"bottom-center"});
                }
            }
            else {
                this.setState({loaderDIV:"d-none",FirstPhotoSrc:imagePlaceholder});
                cogoToast.error("No face detected ! Try again",{position:"bottom-center"});
            }
        })();
    }


    // Second Photo
    SecondPhotoOnChange=()=>{
        let SecondPhotoFile= this.SecondPhoto.files[0];
        let SecondPhotoFileExtension=SecondPhotoFile.name.split('.').pop();
        let validFileExtensions = ["jpg",'JPG',"jpeg",'JPEG',"PNG", "png","gif","GIF"];
        if(!validFileExtensions.includes(SecondPhotoFileExtension)){
            cogoToast.error("Only jpg/png/gif file allowed",{position:"bottom-center"});
        }
        else {
            let reader=new FileReader();
            reader.onload=(e)=>{
                this.setState({SecondPhotoSrc:e.target.result});
            };
            reader.readAsDataURL(SecondPhotoFile);
            this.SecondPhotoDesCal();
        }
    }


    SecondPhotoDesCal=()=>{
        (async ()=>{
            this.setState({loaderDIV:""});
            await  faceapi.loadSsdMobilenetv1Model('/models');
            await  faceapi.loadFaceLandmarkModel('/models');
            await  faceapi.loadFaceRecognitionModel('/models');
            const img=document.getElementById('secondPerson');
            const SingleFace= await faceapi.detectSingleFace(img);
            if(SingleFace){
                const imgDes= await faceapi.detectSingleFace(img).withFaceLandmarks().withFaceDescriptor();
                if(imgDes['descriptor']){
                    this.setState({
                        SecondPhotoDes:imgDes['descriptor']
                    });
                    this.setState({loaderDIV:"d-none"});
                }
                else {
                    this.setState({loaderDIV:"d-none",SecondPhotoSrc:imagePlaceholder});
                    cogoToast.error("No face detected ! Try again",{position:"bottom-center"});
                }
            }
            else {
                this.setState({loaderDIV:"d-none",SecondPhotoSrc:imagePlaceholder});
                cogoToast.error("No face detected ! Try again",{position:"bottom-center"});
            }
        })();
    }


    // Get Matching Result
    FaceMatchingResult=()=>{
      let FirstPhoto= this.state.FirstPhotoDes;
      let SecondPhoto= this.state.SecondPhotoDes;
      if(FirstPhoto.length===0){
          cogoToast.error("Please select first photo",{position:"bottom-center"});
      }
      else if(SecondPhoto.length===0){
          cogoToast.error("Please select second photo",{position:"bottom-center"});
      }
      else {
          let distance= faceapi.euclideanDistance(FirstPhoto,SecondPhoto);
          let similarity=1-distance;
          this.setState({distance:distance});
          this.setState({similarity:similarity});
          if(similarity>0.55){
              this.setState({result:"PASS"});
          }
          else {
              this.setState({result:"FAIL"});
          }
      }
    }






    render() {
        return (
            <Fragment>
                <Animated animationInDelay={400} animationInDuration={400} animationIn="zoomIn" animationOut="fadeOut" isVisible={true}>
                <Container>
                    <Row  className=" mt-5 text-center p-4">
                        <Col  md={4} lg={4} sm={4}>
                            <img alt="first photo" id="firstPerson" className="preview-img" src={this.state.FirstPhotoSrc}/>
                            <input onChange={this.FirstPhotoOnChange} ref={(input)=>this.FirstPhoto=input}  className="d-none" type="file"/>
                            <button className="btn m-2 btn-danger" onClick={()=>{this.FirstPhoto.click()}}>Select First Photo</button>
                        </Col>
                        <Col md={4} lg={4} sm={4}>
                            <img alt="second photo" id="secondPerson" className="preview-img" src={this.state.SecondPhotoSrc}/>
                            <input  onChange={this.SecondPhotoOnChange} ref={(input)=>this.SecondPhoto=input} className="d-none" type="file"/>
                            <button  className="btn m-2  btn-danger" onClick={()=>{this.SecondPhoto.click()}}>Select Second Photo</button>
                        </Col>
                        <Col md={4} lg={4} sm={4}>
                             <div className="input-group">
                                 <CircularProgressbar
                                     className="CircularProgressbar"
                                     value={this.state.similarity}
                                     maxValue={1}
                                     text={`${(this.state.similarity * 100).toFixed(2)}%`}
                                     styles={{path:{stroke: `#5cb85c`}}}/>
                                 <CircularProgressbar
                                     className="CircularProgressbar"
                                     value={this.state.distance}
                                     maxValue={1}
                                     text={`${(this.state.distance * 100).toFixed(2)}%`}
                                     styles={{path: {stroke: `#d9534f`}}}/>
                             </div>
                            <h4 className="text-danger">Result: <b>{this.state.result}</b></h4>
                            <button onClick={this.FaceMatchingResult} className="btn m-2  btn-danger">Get Result</button>
                        </Col>
                    </Row>
                </Container>
                </Animated>
                <div className={this.state.loaderDIV}>
                    <Loader/>
                </div>
            </Fragment>
        );
    }
}
export default FaceMatch;